export default "__VITE_ASSET__DI9pm3B0__"